import { render, staticRenderFns } from "./TestimonialForm.vue?vue&type=template&id=60437d2a&"
import script from "./TestimonialForm.vue?vue&type=script&lang=js&"
export * from "./TestimonialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports